export default __webpack_public_path__ + "static/media/banner-460x200-bg-blue2-template.143f7b8b.svg";